export type CommandThrowable = (...args: any) => any

export class ErrorHandler {

  public async handle(command: CommandThrowable) {
    try {
      return await command();
    } catch (e) {
      console.log(e);
    }
  }

}
